import React from "react";
import Feedback from "../Feedback";
import "./Floaticons.css";
import mailData from ".././../data/mailData";

function Floaticons() {
  return (
    <>
      <div className="float-wrap">
        <div className="floatIcon-innerWrap">
          <div className="float-box box1">
            <p>
              <a href="/ShellUniversity/dashboard">
                <img
                  src="images/Home/dashboard-01.svg"
                  alt="Dashboard icon"
                  className="float-icons"
                />
                Dashboard
              </a>
            </p>
          </div>
          <div className="float-box box2">
            <p>
              <a href={`mailto:${mailData.LKM_ABCUniversity_mail}`}>
                <img
                  src="images/Home/contact-01.svg"
                  alt="contact icon"
                  className="float-icons"
                />
                Contact us
              </a>
            </p>
          </div>
          <Feedback />
          <div className="float-box box4">
            <p>
              <a
                href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxNDA1NTk0NDE5MjAifQ/all"
                target="_blank"
              >
                <img
                  src="images/Home/Yammer icon-01.svg"
                  alt="Yammer Community icon"
                  className="float-icons"
                />
                Yammer Community
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Floaticons;
